import FormControl from 'erxes-ui/lib/components/form/Control';

export default FormControl;
